import { useInitData } from '../../../hooks'
import { getPostProfilePathname } from '../../../utils/link'
import { BirdviewAnnouncementRow } from '../BirdviewAnnouncementRow'
import { BirdviewCard } from '../BirdviewCard'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'

function BirdviewAnnouncementsWidget({
  dragHandleProps,
  section,
  title,
  onNavigate,
}) {
  const { availableSections } = useInitData()
  const { getListTarget } = useBirdviewListTarget()

  function handleOpen(item) {
    onNavigate(getPostProfilePathname({ availableSections, id: item.id }))
  }

  function handleShowAll() {
    onNavigate(getListTarget(BIRDVIEW_SECTION_TARGET.dwellerAnnouncements))
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewAnnouncementRow
          item={item}
          key={item.id}
          onOpen={handleOpen}
        />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewAnnouncementsWidget
